import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game4Store')
@observer
export default class Game4Step1 extends Component {

    componentDidMount() {
        this.props.Game4Store.resetGame();
    }

    render() {
        return (
            <div className="step-1">
                <h1>Fast and Studious</h1>
                <p>How about a game to review the things you’ve studied? Find a team, follow the rules, and have some fun.</p>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game4/Game4Step1.js